import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll(queryArgs = null) {
    const path = `/account/admin/actions`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    results.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return results
  },
  getDepartment(companyId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`account/company/${companyId}/departments`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getBudgetHistory(_, departmentId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`account/company/departments/${departmentId}/budget-history`)
        .then(r => resolve(r.data))
        .catch(e => {
          new EHC(DEFAULTS_HANDLERS).intercept(e)
          reject(e)
        })
    })
  },

  async get(departmentId) {
    const path = `/account/admin/actions/${departmentId}`
    return (await HTTP.get(path)).data
  },

  // async post($, companyId, data) {
  //   const path = `/account/company/${companyId}/departments`
  //   return (await HTTP.post(path, data)).data
  // },

  async post($, companyId, data) {
    const path = `/account/company/${companyId}/departments`

    return HTTP.post(path, data)
      .then(response => response.data)
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        throw error
      })
  },

  // async put(data) {
  //   const { id, ...others } = data
  //   const path = `/account/company/departments/${id}`
  //   return (await HTTP.put(path, others)).data
  // },

  async put(data) {
    const { id, ...others } = data
    const path = `/account/company/departments/${id}`

    return HTTP.put(path, others)
      .then(response => response.data)
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        throw error
      })
  },

  async delete(departmentId) {
    const path = `/account/company/departments/${departmentId}`
    return (await HTTP.delete(path)).data
  }
}
